<template>
  <div class="orders-list-status-filter">
    <div class="orderList">
      <van-tabs @change="handleChange" :border="false">
        <van-tab v-for="item of tabs" :key="item.id" :name="item.id" :title="item.title" />
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        { id: '0', title: '未使用' },
        { id: '1', title: '已使用' },
        { id: '2', title: '退票处理' },
      ],
    };
  },
  methods: {
    handleChange(id) {
      this.$emit('change', id);
    },
  },
};
</script>
<style lang="less" scoped>
.orders-list-status-filter {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
  background: #f9fafb;
  .orderList {
    /deep/ .van-tabs--line {
      border-bottom: 1px solid rgba(114, 119, 123, 0.1);
      /deep/ .van-tabs__wrap {
        height: 40px;
        /deep/ .van-tabs__nav--line {
          height: 40px;
          margin: auto;
          border: none;
          /deep/ .van-tabs__line {
            background: #45b97c;
          }
          /deep/ .van-tab {
            color: #7d7e80;
            // font-weight: 600;
            border: none;
            background: #fff;
            line-height: 40px;
          }
          /deep/ .van-tab--active {
            color: #45b97c;
            // font-weight: 600;
            background-color: #fff;
          }
        }
      }
    }
  }
}
</style>
